module.exports = __webpack_public_path__ + "static/media/preview-thumbnail-2.323fe4af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pseudodocs/preview-thumbnail-2.jpg
// module id = 1888
// module chunks = 2